import * as core from '../../../../../../../core'
import * as proposalStatus from '../proposal-status'

export const RESOURCE = {
  payload: {
    description: '1. Assessing',
    enumId: core.dms.models.Enum.Id.from({
      partialId: proposalStatus.RESOURCE.payload.partialId,
    }),
    id: '1. Assessing',
    name: '1. Assessing',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
